import {createAction} from 'redux-actions';
import callApi from "../../../utils/api/axios";
import {
  getQCDHistory,
  getQCDPDF
} from "../../../utils/api/api-endpoint-dictionary";

const QCD_HISTORY = 'QCD_HISTORY';
const QCD_PDF = 'QCD_PDF';

export default function qcdHistory(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    pdfError: null,
    qcdHistory: [],
    pdfInfo: undefined,
  },
  { payload, type }
) {
  switch (type) {
    case `${QCD_HISTORY}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${QCD_HISTORY}_FULFILLED`:
      return {
          ...state,
          isLoading: false,
          isLoaded: true,
          qcdHistory: payload.data,
        };
    case `${QCD_HISTORY}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        error: payload,
      };
    case `${QCD_PDF}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${QCD_PDF}`:
      payload.data.then((temp) => {
        const blob = new Blob([temp.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = "_blank"
        link.rel="noopener noreferrer"
        //link.download = `${payload.displayName}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      });
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        pdfInfo: true,
      };
    case `${QCD_PDF}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        pdfError: payload,
      };
    default:
      return state;
  }
}

export const QCDHistory = () => {  return (dispatch) => {
  const action = createAction(QCD_HISTORY)(callApi(getQCDHistory));
  dispatch(action);
};
}

export const QCDGetPDF = (id, displayName) => {  return (dispatch) => {
  const action = createAction(QCD_PDF)(
    {
      displayName: displayName,
      data: callApi(
        `${getQCDPDF}/${id}`,
        {method: 'get'},
        false,
        false,
        true
      )
    }
  );
  try {
    dispatch(action);
  } catch (e){
    console.error(e);
  }
};
}
